import React from 'react';
import { useTranslation } from 'react-i18next';
import { Ets2PlaceOfDeliveryStatus } from '../enums/ets2PlaceOfDeliveryStatus';

interface Props {
  status: Ets2PlaceOfDeliveryStatus;
  className?: string;
  asText?: boolean;
}

const Ets2PlaceOfDeliveryStatusLabel = ({ status, className, asText = false }: Props) => {
  const { t } = useTranslation(['ets2\\enums\\ets2PlaceOfDeliveryStatus']);

  const getStatusClass = (status: Ets2PlaceOfDeliveryStatus, asText: boolean, className?: string) => {
    let colorClass = '';
    switch (status) {
      case 'Approved':
        colorClass = 'success';
        break;
      case 'Rejected':
        colorClass = 'danger';
        break;
      case 'Pending':
        colorClass = 'warning';
        break;
      default:
        colorClass = 'secondary';
    }

    const baseClasses = 'small font-weight-normal';
    const contextClass = asText
      ? (colorClass ? `text-${colorClass}` : '')
      : (colorClass ? `badge badge-pill badge-${colorClass}` : 'badge');
    return `${baseClasses} ${contextClass}${className ? ` ${className}` : ''}`;
  };

  return (
    <span className={getStatusClass(status, asText, className)} title={t(status)}>
      {t(status)}
    </span>
  );
};

export default Ets2PlaceOfDeliveryStatusLabel;
